// ecommerce-frontend/src/pages/CartPage.jsx
// CORRECTION FINALE : Styles harmonisés + Logique de données rétablie et fonctionnelle.

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  ShoppingCart, Trash2, Plus, Minus, ArrowRight, Home, ArrowLeft, 
  Package, Truck, DollarSign, Ban 
} from 'lucide-react';
import { cartAPI } from '../services/api'; // authAPI retiré, 'User' retiré de lucide-react

export default function CartPage() {
  const navigate = useNavigate();
  const [cart, setCart] = useState(null);
  const [loading, setLoading] = useState(true);
  // const user = authAPI.getCurrentUser(); // Retiré car inutilisé, causait un warning

  useEffect(() => {
    loadCart();
  }, []);

  const loadCart = async () => {
    try {
      const data = await cartAPI.getCart();
      setCart(data);
    } catch (error) {
      console.error('Erreur chargement panier:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateQuantity = async (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    try {
      await cartAPI.updateCartItem(itemId, newQuantity);
      loadCart();
    } catch (error) {
      alert('Erreur lors de la mise à jour');
    }
  };

  const removeItem = async (itemId) => {
    if (!window.confirm('Retirer cet article du panier ?')) return;
    try {
      // ✅ LOGIQUE RÉTBLIE: Utilisation de removeFromCart, comme dans le fichier original
      await cartAPI.removeFromCart(itemId); 
      loadCart();
    } catch (error) {
      alert('Erreur lors de la suppression');
    }
  };

  const clearCart = async () => {
    if (!window.confirm('Voulez-vous vraiment vider le panier ?')) return;
    try {
      await cartAPI.clearCart();
      loadCart();
    } catch (error) {
      alert('Erreur');
    }
  };

  const handleCheckout = () => {
    navigate('/checkout');
  };

  // ✅ LOGIQUE RÉTBLIE: La fonction est maintenant plus robuste pour les chemins d'images imbriqués
  const getImageUrl = (imagePath) => {
    if (!imagePath) return 'https://via.placeholder.com/80x80?text=Produit';
    if (imagePath.startsWith('http')) return imagePath;
    const baseUrl = 'http://localhost:8000';
    const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
    return `${baseUrl}${cleanPath}`;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center">
        <div className="text-center">
          <div className="relative">
            <div className="animate-spin rounded-full h-20 w-20 border-4 border-orange-500/30 border-t-orange-500 mx-auto mb-6"></div>
            <div className="absolute inset-0 rounded-full h-20 w-20 border-4 border-orange-500/10 blur-xl mx-auto animate-pulse"></div>
          </div>
          <div className="text-xl text-gray-300 font-medium animate-pulse">Chargement de votre panier...</div>
        </div>
      </div>
    );
  }
  
  // ✅ LOGIQUE RÉTBLIE: Utilisation des variables de l'ancien fichier
  const cartItems = cart?.items || [];
  const subtotal = cart?.total || 0; // Utilise cart.total pour le sous-total global
  const shipping = 2000; // Hardcodé comme dans le fichier original
  const total = subtotal + shipping;
  const cartIsEmpty = cartItems.length === 0;

  return (
    // ✅ STYLE HARMONISÉ: Fond et animations
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 -left-20 w-96 h-96 bg-gradient-to-br from-orange-500/20 to-pink-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 -right-20 w-96 h-96 bg-gradient-to-tl from-purple-500/15 to-blue-500/15 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-orange-500/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '500ms' }}></div>
      </div>

      {/* Header Harmonisé */}
      <header className="sticky top-0 z-50 backdrop-blur-2xl bg-white/5 border-b border-white/10 shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button 
                onClick={() => navigate(-1)}
                className="group p-2.5 text-white/70 hover:text-purple-400 hover:bg-white/10 rounded-xl transition-all relative overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-orange-500/0 to-orange-500/20 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <ArrowLeft size={20} className="relative z-10" />
              </button>
              <div 
                className="text-2xl sm:text-3xl font-black bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600 bg-clip-text text-transparent cursor-pointer hover:scale-105 transition-transform"
                onClick={() => navigate('/')}
              >
                MonMarket
              </div>
              <span className="hidden sm:block text-white/20">|</span>
              <span className="hidden sm:flex items-center space-x-2 text-white font-bold">
                <ShoppingCart className="text-orange-400" size={20} />
                <span>Votre Panier</span>
              </span>
            </div>
            <button 
              onClick={() => navigate('/')}
              className="group p-2.5 text-white/70 hover:text-orange-400 hover:bg-white/10 rounded-xl transition-all relative overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/0 to-orange-500/20 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <Home size={20} className="relative z-10" />
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8 relative z-10">
        <h1 className="text-4xl font-black text-white mb-8 flex items-center space-x-3">
          <ShoppingCart className="text-orange-400" size={36} />
          <span>Votre Panier</span>
        </h1>

        {cartIsEmpty ? (
          <div className="relative group">
            {/* Halo de fond */}
            <div className="absolute -inset-0.5 bg-gradient-to-r from-orange-500 to-pink-500 rounded-3xl blur opacity-20 group-hover:opacity-5 transition duration-500"></div>
            <div className="relative bg-white/10 backdrop-blur-2xl rounded-3xl shadow-2xl p-16 text-center border border-white/20">
              <div className="relative inline-block mb-6">
                <div className="absolute inset-0 bg-orange-500/20 rounded-full blur-2xl animate-pulse"></div>
                <div className="relative w-24 h-24 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-xl border border-white/20">
                  <Ban size={48} className="text-orange-400" />
                </div>
              </div>
              <h2 className="text-3xl font-black text-white mb-3">
                Votre panier est vide
              </h2>
              <p className="text-gray-400 mb-8 max-w-md mx-auto">
                Ajoutez des produits pour passer votre première commande.
              </p>
              <button 
                onClick={() => navigate('/')} 
                className="group/btn relative overflow-hidden inline-flex items-center space-x-2"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-pink-600 opacity-0 group-hover/btn:opacity-100 transition-opacity rounded-2xl"></div>
                <div className="relative bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-4 rounded-2xl font-bold shadow-2xl transform group-hover/btn:scale-105 transition-all flex items-center space-x-2">
                  <Package size={20} />
                  <span>Découvrir les produits</span>
                </div>
              </button>
            </div>
          </div>
        ) : (
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 space-y-4">
              
              {/* Conteneur principal des articles avec le bouton Vider le panier */}
              <div className="bg-white/10 backdrop-blur-2xl rounded-3xl shadow-xl p-6 border border-white/20">
                <div className="flex items-center justify-between mb-2">
                  <h2 className="text-xl font-bold text-white">Articles ({cartItems.length})</h2>
                  <button 
                    onClick={clearCart}
                    className="text-red-400 text-sm hover:text-red-300 hover:underline flex items-center space-x-1 p-2 rounded-xl transition"
                  >
                    <Trash2 size={16} />
                    <span>Vider le panier</span>
                  </button>
                </div>
              </div>

              {cartItems.map((item) => (
                <div key={item.id} className="group relative">
                  {/* Halo de fond de la carte article */}
                  <div className="absolute -inset-0.5 bg-gradient-to-r from-orange-500/10 to-pink-500/10 rounded-3xl blur opacity-0 group-hover:opacity-5 transition duration-500"></div>
                  
                  <div className="relative flex items-center bg-white/10 backdrop-blur-2xl rounded-3xl shadow-xl p-6 hover:bg-white/15 transition border border-white/20">
                    <div className="flex items-center space-x-4 w-full">
                      
                      {/* Image */}
                      <img 
                        // ✅ CORRECTION ICI : Utilise item.product?.image comme dans l'original
                        src={getImageUrl(item.product?.image)}
                        alt={item.product?.name}
                        className="w-24 h-24 rounded-xl object-cover flex-shrink-0 border-2 border-white/20 shadow-lg"
                        onError={(e) => {
                          e.target.src = 'https://via.placeholder.com/96x96?text=Image';
                        }}
                      />

                      <div className="flex-1 min-w-0">
                        {/* ✅ CORRECTION ICI : Utilise item.product?.vendor_name et item.product?.name */}
                        <div className="text-xs text-gray-400 mb-1">Vendeur: {item.product?.vendor_name || 'N/A'}</div>
                        <h3 className="font-semibold text-white mb-1 truncate text-lg">{item.product?.name || 'Produit Inconnu'}</h3>
                        <div className="text-orange-400 font-bold text-xl mb-2">
                          {/* Prix unitaire */}
                          {item.product?.price?.toLocaleString() || '0'} FCFA / unité
                        </div>
                        
                        <div className="flex items-center space-x-3">
                          <div className="flex items-center bg-white/10 rounded-xl border border-white/10">
                            <button
                              onClick={() => updateQuantity(item.id, item.quantity - 1)}
                              className="w-8 h-8 flex items-center justify-center text-gray-300 hover:text-white hover:bg-orange-500/20 rounded-l-xl transition disabled:opacity-50"
                              disabled={item.quantity <= 1}
                            >
                              <Minus size={16} />
                            </button>
                            <span className="font-semibold text-white w-8 text-center">{item.quantity}</span>
                            <button
                              onClick={() => updateQuantity(item.id, item.quantity + 1)}
                              className="w-8 h-8 flex items-center justify-center text-gray-300 hover:text-white hover:bg-orange-500/20 rounded-r-xl transition"
                            >
                              <Plus size={16} />
                            </button>
                          </div>
                          
                          <span className="text-sm text-gray-400 ml-4 hidden sm:inline">
                            ({item.product?.stock} disponibles)
                          </span>
                        </div>
                      </div>

                      <div className="text-right flex-shrink-0">
                        <div className="font-black text-white text-2xl mb-4">
                          {/* ✅ CORRECTION ICI : Utilise item.subtotal pour le total de la ligne */}
                          {item.subtotal?.toLocaleString() || '0'} FCFA
                        </div>
                        <button
                          onClick={() => removeItem(item.id)}
                          className="group/trash text-red-400 hover:bg-red-500/20 p-2 rounded-xl transition relative"
                          title="Supprimer"
                        >
                          <div className="absolute -inset-0.5 bg-gradient-to-r from-red-500 to-pink-500 rounded-xl blur opacity-0 group-hover/trash:opacity-10 transition duration-500"></div>
                          <Trash2 size={20} className="relative z-10" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Colonne Droite: Résumé de commande */}
            <div className="lg:col-span-1">
              <div className="bg-white/10 backdrop-blur-2xl rounded-3xl shadow-2xl p-6 sticky top-24 border border-white/20">
                <h3 className="text-xl font-black text-white mb-6 flex items-center space-x-2">
                  <DollarSign className="text-orange-400" size={24} />
                  <span>Résumé de commande</span>
                </h3>
                
                <div className="space-y-4 mb-6">
                  <div className="flex justify-between text-gray-300">
                    <span>Sous-total ({cartItems.length} articles)</span>
                    {/* ✅ CORRECTION ICI : Utilise subtotal (cart.total) */}
                    <span className="font-semibold text-white">{subtotal.toLocaleString()} FCFA</span>
                  </div>
                  <div className="flex justify-between text-gray-300">
                    <span>Frais de livraison estimés</span>
                    {/* ✅ CORRECTION ICI : Utilise shipping (2000) */}
                    <span className="font-semibold text-white">{shipping.toLocaleString()} FCFA</span>
                  </div>
                  <div className="border-t border-white/20 pt-4">
                    <div className="flex justify-between text-white text-lg">
                      <span className="font-bold text-orange-400">Total</span>
                      {/* ✅ CORRECTION ICI : Utilise total (subtotal + shipping) */}
                      <span className="font-black text-white text-2xl">{total.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>

                {/* Bouton de validation */}
                <button 
                  onClick={handleCheckout}
                  className="group relative overflow-hidden w-full mb-3"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-pink-600 rounded-2xl blur opacity-0 group-hover:opacity-100 transition duration-500"></div>
                  <div className="relative flex items-center justify-center space-x-2 bg-gradient-to-r from-orange-500 to-pink-500 text-white py-4 rounded-2xl font-bold shadow-2xl transform group-hover:scale-[1.02] transition-all">
                    <span>Passer la commande</span>
                    <ArrowRight size={20} />
                  </div>
                </button>

                <button 
                  onClick={() => navigate('/')} 
                  className="w-full bg-white/10 border border-orange-500/50 text-orange-400 py-3 rounded-2xl font-semibold hover:bg-white/20 transition-all"
                >
                  Continuer les achats
                </button>

                {/* Info Boxes avec logos officiels */}
<div className="mt-6 p-4 bg-blue-500/20 backdrop-blur-md rounded-2xl border border-blue-400/30">
  <div className="text-sm text-blue-300">
    <div className="font-semibold mb-3 flex items-center space-x-2">
      <DollarSign size={18} />
      <span>Paiement sécurisé</span>
    </div>
    <div className="grid grid-cols-2 gap-3 mb-2">
      {/* MTN Money */}
      <div className="flex items-center justify-center bg-white rounded-lg p-2 h-12">
        <img 
          src="/images/payment/mtn-logo.png"
          alt="MTN Money"
          className="h-full w-auto object-contain"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = '<span class="text-yellow-600 font-bold">MTN</span>';
          }}
        />
      </div>
      {/* Orange Money */}
      <div className="flex items-center justify-center bg-white rounded-lg p-2 h-12">
        <img 
          src="/images/payment/orange-logo.png"
          alt="Orange Money"
          className="h-full w-auto object-contain"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = '<span class="text-orange-600 font-bold">Orange</span>';
          }}
        />
      </div>
      {/* Wave */}
      <div className="flex items-center justify-center bg-white rounded-lg p-2 h-12">
        <img 
          src="/images/payment/wave-logo.png"
          alt="Wave"
          className="h-full w-auto object-contain"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = '<span class="text-blue-600 font-bold">WAVE</span>';
          }}
        />
      </div>
      {/* Moov Money */}
      <div className="flex items-center justify-center bg-white rounded-lg p-2 h-12">
        <img 
          src="/images/payment/moov-logo.png"
          alt="Moov Money"
          className="h-full w-auto object-contain"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = '<span class="text-blue-600 font-bold">moov</span>';
          }}
        />
      </div>
    </div>
    <div className="text-xs text-blue-200 text-center">
      MTN, Orange, Wave, Moov Money ou paiement à la livraison
    </div>
  </div>
</div>


                <div className="mt-4 p-4 bg-green-500/20 backdrop-blur-md rounded-2xl border border-green-400/30">
                  <div className="text-sm text-green-300">
                    <div className="font-semibold mb-2 flex items-center space-x-2"><Truck size={18} /><span>Livraison rapide</span></div>
                    <div className="text-xs text-green-200">
                      Livraison en 2-5 jours ouvrables
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}